/* Arreglo del cajon del carrito.

   El bug: <cart-drawer> nace con la clase `is-empty` si la pagina se cargo con
   el carrito vacio. Al anadir por AJAX, el tema sustituye el HTML de dentro
   (.drawer__inner) pero NO toca las clases del elemento de fuera, asi que
   `is-empty` se queda pegada. Y el CSS del tema, con esa clase, esconde la
   cabecera y la lista. Resultado: se abre un cajon negro y vacio con el
   producto dentro pero invisible.

   Le pasaba a cualquier cliente en su primera compra de la sesion, que es
   justo el peor momento para que parezca que la tienda no funciona.

   OJO con el momento de enganchar: este archivo va en el <head> y el del tema
   (cart-drawer.js) va despues, asi que cuando esto se ejecuta el elemento
   todavia no esta "actualizado" y renderContents aun no existe. Por eso se
   espera con customElements.whenDefined en vez de mirarlo directamente. */
(function () {
  'use strict';

  function sincroniza(drawer) {
    var hayArticulos = !!drawer.querySelector('.cart-item');
    var inner = drawer.querySelector('.drawer__inner');
    drawer.classList.toggle('is-empty', !hayArticulos);
    if (inner) inner.classList.toggle('is-empty', !hayArticulos);
  }

  function parchea() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.npcFix === '1') return;
    if (typeof drawer.renderContents !== 'function') return;
    drawer.dataset.npcFix = '1';

    var original = drawer.renderContents.bind(drawer);
    drawer.renderContents = function (estado) {
      var r = original(estado);
      sincroniza(drawer);
      setTimeout(function () { sincroniza(drawer); }, 0);
      return r;
    };

    /* tambien al quitar la ultima unidad desde dentro del cajon */
    new MutationObserver(function () { sincroniza(drawer); })
      .observe(drawer, { childList: true, subtree: true });

    sincroniza(drawer);
  }

  function arranca() {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer').then(function () {
        parchea();
        setTimeout(parchea, 0);
      });
    }
    /* red de seguridad por si el elemento se define de otra forma */
    var intentos = 0;
    var t = setInterval(function () {
      parchea();
      if (++intentos > 20 || (document.querySelector('cart-drawer') || {}).dataset?.npcFix === '1') {
        clearInterval(t);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }
})();
